export const INSTRUMENTS = [
  { id: "EURUSD", label: "EUR/USD", group: "Forex", contract: 100000, quote: "USD", pointValue: 10, price: 1.0842 },
  { id: "GBPUSD", label: "GBP/USD", group: "Forex", contract: 100000, quote: "USD", pointValue: 10, price: 1.2715 },
  { id: "USDJPY", label: "USD/JPY", group: "Forex", contract: 100000, quote: "JPY", pointValue: 6.4, price: 156.42 },
  { id: "AUDUSD", label: "AUD/USD", group: "Forex", contract: 100000, quote: "USD", pointValue: 10, price: 0.6648 },
  { id: "XAUUSD", label: "Gold (XAU/USD)", group: "Metals", contract: 100, quote: "USD", pointValue: 10, price: 2341.6 },
  { id: "XAGUSD", label: "Silver (XAG/USD)", group: "Metals", contract: 5000, quote: "USD", pointValue: 50, price: 30.41 },
  { id: "US500", label: "US 500", group: "Indices", contract: 1, quote: "USD", pointValue: 1, price: 5312.4 },
  { id: "NAS100", label: "US Tech 100", group: "Indices", contract: 1, quote: "USD", pointValue: 1, price: 18640.2 },
  { id: "GER40", label: "Germany 40", group: "Indices", contract: 1, quote: "EUR", pointValue: 1, price: 18532.0 },
];

export const CURRENCIES = [
  { id: "USD", symbol: "$", factor: 1 },
  { id: "EUR", symbol: "€", factor: 0.92 },
  { id: "GBP", symbol: "£", factor: 0.79 },
];

export const COUNTRIES = [
  "United Kingdom", "Germany", "France", "Spain", "Italy", "Netherlands", "Switzerland",
  "Australia", "Singapore", "United Arab Emirates", "South Africa", "Nigeria", "India",
  "Malaysia", "Thailand", "Vietnam", "Brazil", "Mexico", "Kenya", "Turkey",
];

export const PLATFORMS = ["MT4", "MT5", "cTrader", "TradingView", "No preference"];

// Daily swap in account-currency units (USD) per 1.00 standard lot. Negative = cost, positive = credit.
// Real broker names and logos; all conditions below are SYNTHETIC prototype data, not live quotes.
export const BROKERS = [
  {
    slug: "startrader",
    name: "Startrader",
    short: "Startrader",
    logo: "/brokers/startrader.png",
    tagline: "Razor-account ECN pricing with sub-20ms execution.",
    founded: 2010,
    trust: 9.6,
    entities: [
      { name: "Startrader Limited", regulator: "FCA", jurisdiction: "United Kingdom", ref: "FRN 684312", regions: ["United Kingdom"], leverage: "1:30", bonus: false },
      { name: "Startrader Group Limited", regulator: "ASIC", jurisdiction: "Australia", ref: "AFSL 414530", regions: ["Australia", "Singapore"], leverage: "1:30", bonus: false },
      { name: "Startrader EU Limited", regulator: "CySEC", jurisdiction: "Cyprus", ref: "CIF 388/20", regions: ["Germany", "France", "Spain", "Italy", "Netherlands"], leverage: "1:30", bonus: false },
      { name: "Startrader Markets Limited", regulator: "SCB", jurisdiction: "Bahamas", ref: "SIA-F217", regions: ["United Arab Emirates", "South Africa", "Nigeria", "Malaysia", "Thailand", "Vietnam", "Brazil", "Mexico", "Kenya", "Turkey", "India", "Switzerland"], leverage: "1:500", bonus: false },
    ],
    spreadModel: "Raw ECN",
    eurUsdSpread: 0.1,
    commission: 6.0,
    minDeposit: 200,
    swapFree: true,
    swapFreeNote: "Swap-free on request, 14-day grace then admin fee",
    depositBonus: null,
    platforms: ["cTrader", "MT5", "TradingView", "MT4"],
    funding: ["Bank wire", "Visa / Mastercard", "PayPal", "Skrill", "Crypto (USDT)"],
    withdrawalTime: "Same day (median 4h)",
    withdrawalFee: "Free",
    executionMs: 18,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: -6.1, short: 2.4 }, GBPUSD: { long: -4.3, short: 0.9 }, USDJPY: { long: 18.2, short: -27.8 },
      AUDUSD: { long: -3.1, short: 0.4 }, XAUUSD: { long: -38.4, short: 21.6 }, XAGUSD: { long: -9.8, short: 4.1 },
      US500: { long: -6.9, short: 1.8 }, NAS100: { long: -24.1, short: 6.2 }, GER40: { long: -14.6, short: 2.3 },
    },
    swapUpdated: "2026-06-11T22:05:00Z",
    swapSource: "Daily snapshot",
    highlight: "Lowest measured all-in EUR/USD cost in our panel",
    pros: ["True raw pricing with transparent commission", "Tier-1 regulation in UK, EU and Australia", "Fast, fee-free withdrawals"],
    cons: ["No deposit promotions under any entity", "Minimum deposit higher than peers", "Swap-free accounts incur admin fee after 14 days"],
    limitations: ["Swap data sampled once daily at 22:00 UTC", "Execution latency measured from London VPS only"],
    referral: "https://example.com/go/startrader",
  },
  {
    slug: "xm",
    name: "XM",
    short: "XM",
    logo: "/brokers/xm.png",
    tagline: "Multi-asset broker with genuine swap-free privileges.",
    founded: 2009,
    trust: 9.2,
    entities: [
      { name: "Trading Point of Financial Instruments UK Ltd", regulator: "FCA", jurisdiction: "United Kingdom", ref: "FRN 705428", regions: ["United Kingdom"], leverage: "1:30", bonus: false },
      { name: "Trading Point of Financial Instruments Ltd", regulator: "CySEC", jurisdiction: "Cyprus", ref: "CIF 120/10", regions: ["Germany", "France", "Spain", "Italy", "Netherlands"], leverage: "1:30", bonus: false },
      { name: "XM Global Limited", regulator: "FSC", jurisdiction: "Belize", ref: "000261/397", regions: ["South Africa", "Nigeria", "Kenya", "United Arab Emirates", "Malaysia", "Thailand", "Vietnam", "India", "Turkey", "Brazil", "Mexico"], leverage: "1:1000", bonus: true },
    ],
    spreadModel: "Standard + Ultra Low",
    eurUsdSpread: 0.8,
    commission: 0,
    minDeposit: 5,
    swapFree: true,
    swapFreeNote: "Unconditional swap-free on all Standard accounts",
    depositBonus: "50% trading credit up to $500 (FSC entity only)",
    platforms: ["MT4", "MT5"],
    funding: ["Bank wire", "Visa / Mastercard", "Neteller", "Skrill", "Crypto (BTC, USDT)", "Local transfer"],
    withdrawalTime: "Instant to cards & e-wallets",
    withdrawalFee: "Free",
    executionMs: 32,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: -7.4, short: 1.1 }, GBPUSD: { long: -5.6, short: 0.2 }, USDJPY: { long: 15.9, short: -31.2 },
      AUDUSD: { long: -4.0, short: -0.3 }, XAUUSD: { long: -44.2, short: 18.9 }, XAGUSD: { long: -11.4, short: 2.8 },
      US500: { long: -8.1, short: 0.9 }, NAS100: { long: -27.6, short: 4.0 }, GER40: { long: -15.9, short: 1.4 },
    },
    swapUpdated: "2026-06-11T22:05:00Z",
    swapSource: "Daily snapshot",
    highlight: "Unconditional swap-free Standard accounts",
    pros: ["Swap-free without time limits", "Very low minimum deposit", "Broad funding methods including local rails"],
    cons: ["Wider spreads than ECN peers", "Bonus only available under offshore entity", "No cTrader or TradingView"],
    limitations: ["Withdrawal timing self-reported by broker; 61 user reports verified"],
    referral: "https://example.com/go/xm",
  },
  {
    slug: "ic-markets",
    name: "IC Markets",
    short: "IC Markets",
    logo: "/brokers/ic-markets.png",
    tagline: "Deep FIX liquidity, zero-markup spreads and volume rebates.",
    founded: 2007,
    trust: 9.3,
    entities: [
      { name: "International Capital Markets Pty Ltd", regulator: "ASIC", jurisdiction: "Australia", ref: "AFSL 335692", regions: ["Australia"], leverage: "1:30", bonus: false },
      { name: "IC Markets (EU) Ltd", regulator: "CySEC", jurisdiction: "Cyprus", ref: "CIF 362/18", regions: ["Germany", "France", "Spain", "Italy", "Netherlands"], leverage: "1:30", bonus: false },
      { name: "Raw Trading Ltd", regulator: "FSA", jurisdiction: "Seychelles", ref: "SD 018", regions: ["Singapore", "United Arab Emirates", "South Africa", "Nigeria", "Malaysia", "Thailand", "Vietnam", "Brazil", "Mexico", "Kenya", "Turkey", "India", "Switzerland", "United Kingdom"], leverage: "1:500", bonus: true },
    ],
    spreadModel: "Raw ECN",
    eurUsdSpread: 0.1,
    commission: 7.0,
    minDeposit: 200,
    swapFree: false,
    swapFreeNote: null,
    depositBonus: "$3.50 per lot cashback rebate",
    platforms: ["cTrader", "MT5", "MT4", "TradingView"],
    funding: ["Bank wire", "Visa / Mastercard", "PayPal", "Crypto (USDT, BTC)"],
    withdrawalTime: "< 30 min crypto, 1 day wire",
    withdrawalFee: "Free",
    executionMs: 12,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: -5.4, short: 2.9 }, GBPUSD: { long: -3.8, short: 1.3 }, USDJPY: { long: 20.1, short: -25.6 },
      AUDUSD: { long: -2.7, short: 0.8 }, XAUUSD: { long: -34.9, short: 24.3 }, XAGUSD: { long: -8.6, short: 4.9 },
      US500: { long: -6.2, short: 2.4 }, NAS100: { long: -22.3, short: 7.9 }, GER40: { long: -13.8, short: 3.1 },
    },
    swapUpdated: "2026-06-12T06:40:00Z",
    swapSource: "Live feed",
    highlight: "Lowest holding costs on gold and indices",
    pros: ["Zero-markup spreads on the Raw account", "Live swap publication via API", "12ms median execution"],
    cons: ["No swap-free accounts", "No UK retail entity", "Higher minimum deposit"],
    limitations: ["Cashback rebate terms vary by volume tier; verified for tier 1 only"],
    referral: "https://example.com/go/ic-markets",
  },
  {
    slug: "vantage",
    name: "Vantage",
    short: "Vantage",
    logo: "/brokers/vantage.png",
    tagline: "Accessible global trading with flexible account tiers.",
    founded: 2009,
    trust: 8.6,
    entities: [
      { name: "Vantage Global Prime LLP", regulator: "FCA", jurisdiction: "United Kingdom", ref: "FRN 590299", regions: ["United Kingdom"], leverage: "1:30", bonus: false },
      { name: "Vantage Global Prime Pty Ltd", regulator: "ASIC", jurisdiction: "Australia", ref: "AFSL 428901", regions: ["Australia"], leverage: "1:30", bonus: false },
      { name: "Vantage Global Limited", regulator: "VFSC", jurisdiction: "Vanuatu", ref: "No. 700271", regions: ["Singapore", "United Arab Emirates", "South Africa", "Nigeria", "Malaysia", "Thailand", "Vietnam", "Brazil", "Mexico", "Kenya", "Turkey", "India", "Switzerland", "Germany", "France", "Spain", "Italy", "Netherlands"], leverage: "1:500", bonus: true },
    ],
    spreadModel: "Standard + Raw",
    eurUsdSpread: 1.0,
    commission: 0,
    minDeposit: 50,
    swapFree: true,
    swapFreeNote: "Swap-free for 30 days, then standard swaps apply",
    depositBonus: "50% welcome bonus up to $500 (VFSC entity only)",
    platforms: ["MT4", "MT5", "TradingView"],
    funding: ["Visa / Mastercard", "Skrill", "Neteller", "Crypto (USDT)", "Local transfer", "Bank wire"],
    withdrawalTime: "Under 2 hours (e-wallets)",
    withdrawalFee: "Free",
    executionMs: 45,
    tripleSwapDay: 5,
    swaps: {
      EURUSD: { long: -8.9, short: 0.3 }, GBPUSD: { long: -6.5, short: -0.6 }, USDJPY: { long: 12.4, short: -34.8 },
      AUDUSD: { long: -4.9, short: -1.1 }, XAUUSD: { long: -51.2, short: 14.6 }, XAGUSD: { long: -13.1, short: 1.9 },
      US500: { long: -9.4, short: 0.2 }, NAS100: { long: -31.0, short: 2.1 }, GER40: { long: -17.8, short: 0.6 },
    },
    swapUpdated: "2026-06-10T22:00:00Z",
    swapSource: "Delayed",
    highlight: "Welcome bonus with wide local payment coverage",
    pros: ["Low minimum deposit", "Welcome bonus under offshore entity", "Wide local payment coverage"],
    cons: ["Highest overnight costs on majors", "Swap-free is time-limited", "Slower execution than ECN peers"],
    limitations: ["Swap snapshot is 36h old — treated as delayed", "Bonus terms carry 30-lot turnover requirement"],
    referral: "https://example.com/go/vantage",
  },
  {
    slug: "fxpro",
    name: "FxPro",
    short: "FxPro",
    logo: "/brokers/fxpro.png",
    tagline: "No-dealing-desk execution with segregated client funds.",
    founded: 2006,
    trust: 9.4,
    entities: [
      { name: "FxPro UK Limited", regulator: "FCA", jurisdiction: "United Kingdom", ref: "FRN 509956", regions: ["United Kingdom"], leverage: "1:30", bonus: false },
      { name: "FxPro Financial Services Ltd", regulator: "CySEC", jurisdiction: "Cyprus", ref: "CIF 078/07", regions: ["Germany", "France", "Spain", "Italy", "Netherlands", "Switzerland"], leverage: "1:30", bonus: false },
      { name: "FxPro Financial Services (Pty) Ltd", regulator: "FSCA", jurisdiction: "South Africa", ref: "FSP 45052", regions: ["South Africa", "Kenya", "Nigeria"], leverage: "1:200", bonus: false },
      { name: "FxPro Global Markets Ltd", regulator: "SCB", jurisdiction: "Bahamas", ref: "SIA-F184", regions: ["Singapore", "Australia", "United Arab Emirates", "Malaysia", "Thailand", "India", "Vietnam", "Brazil", "Mexico", "Turkey"], leverage: "1:500", bonus: false },
    ],
    spreadModel: "Raw + Standard",
    eurUsdSpread: 0.2,
    commission: 7.0,
    minDeposit: 100,
    swapFree: true,
    swapFreeNote: "Swap-free available on verified religious grounds",
    depositBonus: null,
    platforms: ["MT5", "MT4", "cTrader", "TradingView"],
    funding: ["Bank wire (SEPA / SWIFT)", "Visa / Mastercard", "PayPal", "Skrill", "Neteller"],
    withdrawalTime: "Same-day e-wallets, 1 day wire",
    withdrawalFee: "Free",
    executionMs: 15,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: -5.8, short: 2.6 }, GBPUSD: { long: -4.1, short: 1.0 }, USDJPY: { long: 19.0, short: -26.9 },
      AUDUSD: { long: -2.9, short: 0.6 }, XAUUSD: { long: -36.1, short: 22.8 }, XAGUSD: { long: -9.1, short: 4.4 },
      US500: { long: -6.6, short: 2.0 }, NAS100: { long: -23.4, short: 6.8 }, GER40: { long: -14.1, short: 2.7 },
    },
    swapUpdated: "2026-06-11T22:05:00Z",
    swapSource: "Daily snapshot",
    highlight: "Longest Tier-1 track record in the panel",
    pros: ["Regulated since 2006 across four jurisdictions", "Competitive raw pricing on cTrader", "Negative balance protection on all entities"],
    cons: ["Commission above the cheapest ECN peers", "No crypto funding", "No promotions"],
    limitations: ["Not available to residents outside listed regions"],
    referral: "https://example.com/go/fxpro",
  },
  {
    slug: "exness",
    name: "Exness",
    short: "Exness",
    logo: "/brokers/exness.png",
    tagline: "Instant automated withdrawals and extended swap-free trading.",
    founded: 2008,
    trust: 9.0,
    entities: [
      { name: "Exness (Cy) Ltd", regulator: "CySEC", jurisdiction: "Cyprus", ref: "CIF 178/12", regions: ["Germany", "France", "Spain", "Italy", "Netherlands"], leverage: "1:30", bonus: false },
      { name: "Exness ZA (Pty) Ltd", regulator: "FSCA", jurisdiction: "South Africa", ref: "FSP 51024", regions: ["South Africa"], leverage: "1:2000", bonus: false },
      { name: "Exness (Ke) Limited", regulator: "CMA", jurisdiction: "Kenya", ref: "No. 162", regions: ["Kenya"], leverage: "1:400", bonus: false },
      { name: "Exness (SC) Ltd", regulator: "FSA", jurisdiction: "Seychelles", ref: "SD 025", regions: ["Nigeria", "United Arab Emirates", "Malaysia", "Thailand", "Vietnam", "India", "Turkey", "Brazil", "Mexico", "Singapore"], leverage: "1:2000", bonus: false },
    ],
    spreadModel: "Standard + Raw",
    eurUsdSpread: 1.0,
    commission: 0,
    minDeposit: 10,
    swapFree: true,
    swapFreeNote: "Extended swap-free by default on most forex, gold and indices",
    depositBonus: null,
    platforms: ["MT4", "MT5", "TradingView"],
    funding: ["Visa / Mastercard", "Skrill", "Neteller", "Crypto (USDT, BTC)", "Local transfer", "Bank wire"],
    withdrawalTime: "Instant (automated, 98% of requests)",
    withdrawalFee: "Free",
    executionMs: 24,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: -6.8, short: 1.7 }, GBPUSD: { long: -4.9, short: 0.5 }, USDJPY: { long: 16.8, short: -29.4 },
      AUDUSD: { long: -3.6, short: 0.1 }, XAUUSD: { long: 0, short: 0 }, XAGUSD: { long: -10.6, short: 3.2 },
      US500: { long: -7.5, short: 1.2 }, NAS100: { long: -26.0, short: 4.9 }, GER40: { long: -15.2, short: 1.8 },
    },
    swapUpdated: "2026-06-12T05:10:00Z",
    swapSource: "Live feed",
    highlight: "Instant withdrawals and swap-free gold by default",
    pros: ["Automated instant withdrawals", "Swap-free gold without application", "Unlimited leverage tiers under offshore entities"],
    cons: ["No UK retail entity", "Standard spreads wider than ECN peers", "Very high leverage can amplify losses"],
    limitations: ["Swap-free eligibility varies by region and instrument", "Instant-withdrawal rate self-reported by broker"],
    referral: "https://example.com/go/exness",
  },
  {
    slug: "tickmill",
    name: "Tickmill",
    short: "Tickmill",
    logo: "/brokers/tickmill.png",
    tagline: "Low-commission raw pricing with a conservative balance sheet.",
    founded: 2014,
    trust: 9.1,
    entities: [
      { name: "Tickmill UK Ltd", regulator: "FCA", jurisdiction: "United Kingdom", ref: "FRN 717270", regions: ["United Kingdom"], leverage: "1:30", bonus: false },
      { name: "Tickmill Europe Ltd", regulator: "CySEC", jurisdiction: "Cyprus", ref: "CIF 278/15", regions: ["Germany", "France", "Spain", "Italy", "Netherlands"], leverage: "1:30", bonus: false },
      { name: "Tickmill South Africa (Pty) Ltd", regulator: "FSCA", jurisdiction: "South Africa", ref: "FSP 49464", regions: ["South Africa", "Kenya", "Nigeria"], leverage: "1:500", bonus: false },
      { name: "Tickmill Ltd", regulator: "FSA", jurisdiction: "Seychelles", ref: "SD 008", regions: ["Singapore", "Australia", "United Arab Emirates", "Malaysia", "Thailand", "Vietnam", "India", "Turkey", "Brazil", "Mexico", "Switzerland"], leverage: "1:1000", bonus: true },
    ],
    spreadModel: "Raw ECN",
    eurUsdSpread: 0.2,
    commission: 6.0,
    minDeposit: 100,
    swapFree: true,
    swapFreeNote: "Swap-free on Raw and Classic for eligible clients",
    depositBonus: "$30 welcome account (FSA entity only)",
    platforms: ["MT4", "MT5", "TradingView"],
    funding: ["Bank wire", "Visa / Mastercard", "Skrill", "Neteller", "Crypto (USDT)"],
    withdrawalTime: "Same day (e-wallets within 1h)",
    withdrawalFee: "Free",
    executionMs: 20,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: -6.3, short: 2.1 }, GBPUSD: { long: -4.5, short: 0.8 }, USDJPY: { long: 17.6, short: -28.3 },
      AUDUSD: { long: -3.3, short: 0.3 }, XAUUSD: { long: -39.7, short: 20.4 }, XAGUSD: { long: -10.1, short: 3.8 },
      US500: { long: -7.0, short: 1.6 }, NAS100: { long: -24.8, short: 5.7 }, GER40: { long: -14.9, short: 2.0 },
    },
    swapUpdated: "2026-06-11T22:05:00Z",
    swapSource: "Daily snapshot",
    highlight: "Lowest commission among Tier-1 raw accounts",
    pros: ["$6 round-turn commission on Raw", "Four regulated entities including FCA and CySEC", "Fast e-wallet withdrawals"],
    cons: ["No cTrader", "Welcome bonus restricted to offshore entity", "Fewer exotic instruments than peers"],
    limitations: ["Welcome account capped at $30 with withdrawal conditions"],
    referral: "https://example.com/go/tickmill",
  },
  {
    slug: "tmgm",
    name: "TMGM",
    short: "TMGM",
    logo: "/brokers/tmgm.png",
    tagline: "Asia-Pacific ECN specialist with institutional liquidity.",
    founded: 2013,
    trust: 8.7,
    entities: [
      { name: "Trademax Australia Limited", regulator: "ASIC", jurisdiction: "Australia", ref: "AFSL 436416", regions: ["Australia"], leverage: "1:30", bonus: false },
      { name: "Trademax Global Markets (NZ) Limited", regulator: "FMA", jurisdiction: "New Zealand", ref: "FSP 569807", regions: ["Singapore"], leverage: "1:100", bonus: false },
      { name: "TMGM Global Limited", regulator: "VFSC", jurisdiction: "Vanuatu", ref: "No. 40356", regions: ["United Arab Emirates", "Malaysia", "Thailand", "Vietnam", "India", "South Africa", "Nigeria", "Kenya", "Turkey", "Brazil", "Mexico"], leverage: "1:1000", bonus: true },
    ],
    spreadModel: "Raw ECN",
    eurUsdSpread: 0.1,
    commission: 7.0,
    minDeposit: 100,
    swapFree: true,
    swapFreeNote: "Islamic account on request, no time limit",
    depositBonus: "Loyalty rebates up to $2 per lot (VFSC entity only)",
    platforms: ["MT4", "MT5", "TradingView"],
    funding: ["Bank wire", "Visa / Mastercard", "Skrill", "Neteller", "Crypto (USDT)", "Local transfer"],
    withdrawalTime: "Within 24 hours",
    withdrawalFee: "Free",
    executionMs: 28,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: -6.6, short: 1.9 }, GBPUSD: { long: -4.8, short: 0.6 }, USDJPY: { long: 17.1, short: -29.0 },
      AUDUSD: { long: -3.4, short: 0.2 }, XAUUSD: { long: -41.3, short: 19.5 }, XAGUSD: { long: -10.4, short: 3.5 },
      US500: { long: -7.3, short: 1.4 }, NAS100: { long: -25.6, short: 5.1 }, GER40: { long: -15.4, short: 1.7 },
    },
    swapUpdated: "2026-06-11T22:05:00Z",
    swapSource: "Daily snapshot",
    highlight: "Deep APAC liquidity with no-time-limit Islamic accounts",
    pros: ["ASIC and FMA regulation", "Raw spreads from 0.0 on majors", "Islamic accounts without expiry"],
    cons: ["No UK or EU entity", "Rebates only under offshore entity", "Withdrawals slower than instant peers"],
    limitations: ["Liquidity depth measured during Asia session only"],
    referral: "https://example.com/go/tmgm",
  },
  {
    slug: "xtb",
    name: "XTB",
    short: "XTB",
    logo: "/brokers/xtb.png",
    tagline: "Listed broker with proprietary xStation platform and zero minimum deposit.",
    founded: 2002,
    trust: 9.3,
    entities: [
      { name: "XTB Limited", regulator: "FCA", jurisdiction: "United Kingdom", ref: "FRN 522157", regions: ["United Kingdom"], leverage: "1:30", bonus: false },
      { name: "XTB S.A.", regulator: "KNF", jurisdiction: "Poland", ref: "DDM-M-4021-57-1/2005", regions: ["Germany", "France", "Spain", "Italy", "Netherlands"], leverage: "1:30", bonus: false },
      { name: "XTB MENA Limited", regulator: "DFSA", jurisdiction: "United Arab Emirates", ref: "F006316", regions: ["United Arab Emirates"], leverage: "1:30", bonus: false },
      { name: "XTB International Limited", regulator: "FSC", jurisdiction: "Belize", ref: "000302/46", regions: ["South Africa", "Nigeria", "Kenya", "Malaysia", "Thailand", "Vietnam", "India", "Turkey", "Brazil", "Mexico", "Singapore", "Australia", "Switzerland"], leverage: "1:500", bonus: false },
    ],
    spreadModel: "Standard",
    eurUsdSpread: 0.9,
    commission: 0,
    minDeposit: 0,
    swapFree: false,
    swapFreeNote: null,
    depositBonus: null,
    platforms: ["xStation 5"],
    funding: ["Bank wire", "Visa / Mastercard", "PayPal", "Skrill", "Local transfer"],
    withdrawalTime: "1 business day",
    withdrawalFee: "Free above $100",
    executionMs: 35,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: -8.2, short: 0.7 }, GBPUSD: { long: -6.0, short: -0.2 }, USDJPY: { long: 13.9, short: -33.1 },
      AUDUSD: { long: -4.5, short: -0.8 }, XAUUSD: { long: -48.0, short: 16.2 }, XAGUSD: { long: -12.4, short: 2.3 },
      US500: { long: -8.9, short: 0.5 }, NAS100: { long: -29.7, short: 3.0 }, GER40: { long: -16.9, short: 1.0 },
    },
    swapUpdated: "2026-06-11T22:05:00Z",
    swapSource: "Daily snapshot",
    highlight: "Publicly listed broker with no minimum deposit",
    pros: ["Listed on the Warsaw Stock Exchange", "No minimum deposit", "Award-winning proprietary platform"],
    cons: ["No MetaTrader or cTrader", "No swap-free accounts", "Wider standard spreads"],
    limitations: ["Platform preference filter will not match MT4/MT5/cTrader users"],
    referral: "https://example.com/go/xtb",
  },
  {
    slug: "givtrade",
    name: "GivTrade",
    short: "GivTrade",
    logo: "/brokers/givtrade.png",
    tagline: "Emerging-markets specialist with local funding rails.",
    founded: 2018,
    trust: 7.8,
    entities: [
      { name: "GivTrade (Pty) Ltd", regulator: "FSCA", jurisdiction: "South Africa", ref: "FSP 51022", regions: ["South Africa", "Nigeria", "Kenya"], leverage: "1:1000", bonus: true },
      { name: "GivTrade International Ltd", regulator: "FSC", jurisdiction: "Mauritius", ref: "GB21026", regions: ["India", "Malaysia", "Thailand", "Vietnam", "United Arab Emirates", "Brazil", "Mexico", "Turkey"], leverage: "1:1000", bonus: true },
    ],
    spreadModel: "Standard",
    eurUsdSpread: 1.1,
    commission: 0,
    minDeposit: 10,
    swapFree: true,
    swapFreeNote: "Swap-free by default on all accounts",
    depositBonus: "100% deposit bonus up to $1,000 (tradable credit)",
    platforms: ["MT4", "MT5"],
    funding: ["Local transfer", "Mobile money", "Crypto (USDT)", "Visa / Mastercard"],
    withdrawalTime: "Under 1 hour (local rails)",
    withdrawalFee: "Free",
    executionMs: 68,
    tripleSwapDay: 3,
    swaps: {
      EURUSD: { long: 0, short: 0 }, GBPUSD: { long: 0, short: 0 }, USDJPY: { long: 0, short: 0 },
      AUDUSD: { long: 0, short: 0 }, XAUUSD: { long: 0, short: 0 }, XAGUSD: { long: 0, short: 0 },
      US500: { long: 0, short: 0 }, NAS100: { long: 0, short: 0 }, GER40: { long: 0, short: 0 },
    },
    swapUpdated: null,
    swapSource: "Unavailable",
    highlight: "100% deposit bonus and default swap-free pricing",
    pros: ["Largest deposit bonus in the panel", "Mobile money and local rails", "Swap-free by default"],
    cons: ["Widest spreads in the panel", "Tier-3 regulation only", "Slowest execution measured"],
    limitations: ["Swap-free accounts carry wider spreads instead of overnight fees; no published swap table", "Not available to UK, EU, AU or CH residents"],
    referral: "https://example.com/go/givtrade",
  },
];

export const getBroker = (slug) => BROKERS.find((b) => b.slug === slug);
export const getInstrument = (id) => INSTRUMENTS.find((i) => i.id === id);
